<div class="show-submittals">
  <procure-expansion-panel
    flat
    [label]="label() ?? null"
  >
    @if (hint()) {
      <div formRow>
        <procure-hint class="show-submittals__hint">
          {{ hint() }}
        </procure-hint>
      </div>
    }
    @if (value()?.length) {
      <ol class="show-submittals__options">
        @for (item of value(); track item.id; let i = $index) {
          <li class="show-submittals__item">
            <div class="show-submittals__value">
              <procure-checkbox
                disabled
                [checked]="item.isChecked"
              >
                {{ item.name }}
              </procure-checkbox>
            </div>
            @if (item.isChecked) {
              <div class="show-submittals__description">
                <procure-show-field [label]="additionalLabel()">
                  {{ item.comment || "-" }}
                </procure-show-field>
              </div>
            }
          </li>
        }
      </ol>
    }
    @if (!value()?.length) {
      <div class="show-submittals__empty">-</div>
    }
  </procure-expansion-panel>
</div>
